import { cn } from "@/utils/theme";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import type { NodeData } from "@/workflow_api/types/workflow";
import { Icon } from "@elaniintc/goes-design-system";
import { VariableKeyBox } from "../key-box";
import { Operations } from "@/workflow/components/configurations/calculated-field/CalculatedFieldOperation/utils/operations";
import { parseType } from "@/workflow_api/hooks/variables/useGetVariables";

interface Props {
  id: string;
}

const Content = ({ data }: { data: NodeData }) => {
  if (!data) {
    return (
      <Icon
        name="spinner-third"
        className="animate-spin text-sm text-on-disabled"
        type="far"
      />
    );
  }

  const type = data?.inputs[0]?.calculations?.[0].inputs[0].type;
  const operation = data?.inputs[0]?.calculations?.[0].operation;
  const outputType = Operations[
    parseType(type?.toLowerCase() || "") as keyof typeof Operations
  ]?.find((op) => op.name === operation?.toLowerCase())?.output;
  return (
    <div className="flex">
      <div
        className={cn(
          "w-0.5 relative translate-x-[25px]",
          "bg-neutral-object-accent",
        )}
      >
        <span className="absolute left-3 top-[14px] w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] mb-4 w-full">
        <div className="py-1">
          <div className="space-y-3">
            <VariableKeyBox
              name={data.displayName}
              type={(outputType as "string" | "number" | "array") || "string"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const CalculatedFieldVariables = ({ id }: Props) => {
  const { getNodeById } = useWorkflowStore();
  const node = getNodeById(id);
  if (!node) return <></>;
  const nodeData = node.data as unknown as NodeData;
  return <Content data={nodeData} />;
};
